import { useRef, useEffect } from 'react';

/**
 * @see https://usehooks.com/usePrevious/
 */
const usePrevious = value => {
  const ref = useRef();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
};

export { usePrevious };
